import { useRef } from 'react';
import { Button } from 'common/components/Button';
import { useDecorativeVideo } from 'common/hook/useDecorativeVideo';
import { useHeroIntroAnimation } from 'common/hook/useHeroIntroAnimation';
import { useTranslation } from 'next-i18next';

export const HeroService: React.FC<{ translationKey: string }> = ({ translationKey }) => {
  const { t } = useTranslation('pageServices');
  const el = useRef<HTMLElement | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  useHeroIntroAnimation({
    scopeRef: el,
    revealAnimations: [
      { delay: 1.8, selector: '#hero-text', toVars: { opacity: 1, translateY: 0 } },
      { delay: 2, selector: '#hero-button', toVars: { opacity: 1, translateY: 0 } },
    ],
  });
  useDecorativeVideo(videoRef);

  return (
    <section
      ref={el}
      className="bg-gradient top-0 flex min-h-[100vh] w-[100vw] flex-col items-center justify-center overflow-hidden pb-6 pt-48 md:sticky md:pt-32 lg:pb-10 lg:pt-32">
      <video
        ref={videoRef}
        className="absolute bottom-0 right-0 h-full w-[100vw] object-cover"
        loop
        autoPlay
        muted
        playsInline
        preload="metadata"
        aria-hidden="true"
        tabIndex={-1}
        disablePictureInPicture
        role="presentation">
        <source
          src="https://firebasestorage.googleapis.com/v0/b/nordit-83a0b.appspot.com/o/heroVideo.mp4?alt=media&token=5544cf62-e98e-4a23-8ef3-99ccee509131"
          type="video/mp4"
        />
      </video>
      <div className="bg-gradient absolute bottom-0 left-0 right-0 top-0 opacity-[0.96]" />
      <div className="container">
        <h1
          id="hero-title"
          className="text-heading-hero"
          style={{ opacity: 0, visibility: 'hidden' }}
          dangerouslySetInnerHTML={{ __html: t(`serviceSingle.${translationKey}.title`) }}
        />

        <div
          id="hero-text"
          className="my-10 max-w-xl translate-y-4 text-white opacity-0"
          dangerouslySetInnerHTML={{
            __html: t(`serviceSingle.${translationKey}.description`),
          }}
        />

        <div id="hero-button" className="translate-y-6 opacity-0 flex mt-6">
          <Button href={t('common:contactProjectSlug')}>{t('common:bookADiscoverCall')}</Button>
        </div>
      </div>
    </section>
  );
};
